import React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  CONSTANTS,
  REPORT_TYPES,
  SOCIAL_SOURCES_OPTIONS,
  VERTICALS,
  WORD_CLOUD_TYPE,
  HOTSTAR_ID,
  GRAPH_TYPES,
  REPORT_CATEGORIES,
} from "../../../constants/app-constant";
import { CustomBSDropdown } from "../../Shared";

const { V_PRINT, V_ONLINE, V_SOCIAL, V_FORUM, V_BLOG } = VERTICALS;

const {
  SOVEntityTonalityCCM,
  SOVEntityTonalityMAV,
  SOVEntityTonalityIndex,
  SOVEntityTonalityNOA,
  SOVEntityTonalityWordCount,
  SOVEntityTonalityReach,
  SOVJournalistTonalityIndex,
  SOVJournalistTonalityNOA,
  SOVJournalistTonalityMAV,
  SOVJournalistTonalityWordCount,
  SOVJournalistTonalityCCM,
  SOVJournalistTonalityReach,
  SOVKeywordTonalityIndex,
  SOVKeywordTonalityNOA,
  SOVKeywordTonalityMAV,
  SOVKeywordTonalityWordCount,
  SOVKeywordTonalityCCM,
  SOVKeywordTonalityReach,
  SOVKeywordTrendIndex,
  SOVKeywordTrendNOA,
  SOVKeywordTrendMAV,
  SOVKeywordTrendWordCount,
  SOVKeywordTrendCCM,
  SOVKeywordTrendReach,
  SOVPublicationTrendIndex,
  SOVPublicationTrendNOA,
  SOVPublicationTrendMAV,
  SOVPublicationTrendWordCount,
  SOVPublicationTrendCCM,
  SOVPublicationTrendReach,
  SOVCityTrendIndex,
  SOVCityTrendNOA,
  SOVCityTrendMAV,
  SOVCityTrendWordCount,
  SOVCityTrendCCM,
  SOVCityTrendReach,
  SOVKeywordRankingIndex,
  SOVKeywordRankingNOA,
  SOVKeywordRankingMAV,
  SOVKeywordRankingWordCount,
  SOVKeywordRankingCCM,
  SOVKeywordRankingReach,
  SOVCityRankingIndex,
  SOVCityRankingNOA,
  SOVCityRankingMAV,
  SOVCityRankingWordCount,
  SOVCityRankingCCM,
  SOVCityRankingReach,
  SOVCityTonalityIndex,
  SOVCityTonalityNOA,
  SOVCityTonalityMAV,
  SOVCityTonalityWordCount,
  SOVCityTonalityCCM,
  SOVCityTonalityReach,
  SOVPublicationTonalityIndex,
  SOVPublicationTonalityNOA,
  SOVPublicationTonalityMAV,
  SOVPublicationTonalityWordCount,
  SOVPublicationTonalityCCM,
  SOVPublicationTonalityReach,
  SOVPublicationRankingIndex,
  SOVPublicationRankingNOA,
  SOVPublicationRankingMAV,
  SOVPublicationRankingWordCount,
  SOVPublicationRankingCCM,
  SOVPublicationRankingReach,
  SOVJournalistRankingIndex,
  SOVJournalistRankingNOA,
  SOVJournalistRankingMAV,
  SOVJournalistRankingWordCount,
  SOVJournalistRankingCCM,
  SOVJournalistRankingReach,
  SOVJournalistTrendIndex,
  SOVJournalistTrendNOA,
  SOVJournalistTrendMAV,
  SOVJournalistTrendWordCount,
  SOVJournalistTrendCCM,
  SOVJournalistTrendReach,

  SentimentEntityTrendCCM,
  SentimentEntityTrendIndex,
  SentimentEntityTrendNOA,
  SentimentEntityTrendMAV,
  SentimentEntityTrendWordCount,
  SentimentEntityTrendReach,
  SentimentEntitySOVCCM,
  SentimentEntitySOVIndex,
  SentimentEntitySOVNOA,
  SentimentEntitySOVMAV,
  SentimentEntitySOVWordCount,
  SentimentEntitySOVReach,

  SentimentJournalistTrendCCM,
  SentimentJournalistTrendIndex,
  SentimentJournalistTrendNOA,
  SentimentJournalistTrendMAV,
  SentimentJournalistTrendWordCount,
  SentimentJournalistTrendReach,
  SentimentJournalistSOVCCM,
  SentimentJournalistSOVIndex,
  SentimentJournalistSOVNOA,
  SentimentJournalistSOVMAV,
  SentimentJournalistSOVWordCount,
  SentimentJournalistSOVReach,

  SentimentPublicationTrendCCM,
  SentimentPublicationTrendIndex,
  SentimentPublicationTrendNOA,
  SentimentPublicationTrendMAV,
  SentimentPublicationTrendWordCount,
  SentimentPublicationTrendReach,
  SentimentPublicationSOVCCM,
  SentimentPublicationSOVIndex,
  SentimentPublicationSOVNOA,
  SentimentPublicationSOVMAV,
  SentimentPublicationSOVWordCount,
  SentimentPublicationSOVReach,

  SentimentCityTrendCCM,
  SentimentCityTrendIndex,
  SentimentCityTrendNOA,
  SentimentCityTrendMAV,
  SentimentCityTrendReach,
  SentimentCitySOVCCM,
  SentimentCitySOVIndex,
  SentimentCitySOVNOA,
  SentimentCitySOVMAV,
  SentimentCitySOVReach,

  SentimentKeywordTrendCCM,
  SentimentKeywordTrendIndex,
  SentimentKeywordTrendNOA,
  SentimentKeywordTrendMAV,
  SentimentKeywordTrendWordCount,
  SentimentKeywordTrendReach,
  SentimentKeywordSOVCCM,
  SentimentKeywordSOVIndex,
  SentimentKeywordSOVNOA,
  SentimentKeywordSOVMAV,
  SentimentKeywordSOVWordCount,
  SentimentKeywordSOVReach,

  SpokespersonEntityTrendCCM,
  SpokespersonEntityTrendIndex,
  SpokespersonEntityTrendNOA,
  SpokespersonEntityTrendMAV,
  SpokespersonEntityTrendWordCount,
  SpokespersonEntityTrendReach,
  SpokespersonEntitySOVCCM,
  SpokespersonEntitySOVIndex,
  SpokespersonEntitySOVNOA,
  SpokespersonEntitySOVMAV,
  SpokespersonEntitySOVWordCount,
  SpokespersonEntitySOVReach,

  SpokespersonJournalistTrendCCM,
  SpokespersonJournalistTrendIndex,
  SpokespersonJournalistTrendNOA,
  SpokespersonJournalistTrendMAV,
  SpokespersonJournalistTrendWordCount,
  SpokespersonJournalistTrendReach,
  SpokespersonJournalistSOVCCM,
  SpokespersonJournalistSOVIndex,
  SpokespersonJournalistSOVNOA,
  SpokespersonJournalistSOVMAV,
  SpokespersonJournalistSOVWordCount,
  SpokespersonJournalistSOVReach,

  SpokespersonTopicTrendCCM,
  SpokespersonTopicTrendIndex,
  SpokespersonTopicTrendNOA,
  SpokespersonTopicTrendMAV,
  SpokespersonTopicTrendWordCount,
  SpokespersonTopicTrendReach,
  SpokespersonTopicSOVCCM,
  SpokespersonTopicSOVIndex,
  SpokespersonTopicSOVNOA,
  SpokespersonTopicSOVMAV,
  SpokespersonTopicSOVWordCount,
  SpokespersonTopicSOVReach,

  SpokespersonProfileTrendCCM,
  SpokespersonProfileTrendIndex,
  SpokespersonProfileTrendNOA,
  SpokespersonProfileTrendMAV,
  SpokespersonProfileTrendWordCount,
  SpokespersonProfileTrendReach,
  SpokespersonProfileSOVCCM,
  SpokespersonProfileSOVIndex,
  SpokespersonProfileSOVNOA,
  SpokespersonProfileSOVMAV,
  SpokespersonProfileSOVWordCount,
  SpokespersonProfileSOVReach,

  JournalistEntityTonalityIndex,
  JournalistEntityTonalityNOA,
  JournalistEntityTonalityMAV,
  JournalistEntityTonalityWordCount,
  JournalistEntityTonalityCCM,
  JournalistEntityTonalityReach,
  JournalistEntityTrendIndex,
  JournalistEntityTrendNOA,
  JournalistEntityTrendMAV,
  JournalistEntityTrendWordCount,
  JournalistEntityTrendCCM,
  JournalistEntityTrendReach,

  JournalistKeywordTonalityIndex,
  JournalistKeywordTonalityNOA,
  JournalistKeywordTonalityMAV,
  JournalistKeywordTonalityWordCount,
  JournalistKeywordTonalityCCM,
  JournalistKeywordTonalityReach,
  JournalistKeywordTrendIndex,
  JournalistKeywordTrendNOA,
  JournalistKeywordTrendMAV,
  JournalistKeywordTrendWordCount,
  JournalistKeywordTrendCCM,
  JournalistKeywordTrendReach,

  KeywordEntityTonalityIndex,
  KeywordEntityTonalityNOA,
  KeywordEntityTonalityMAV,
  KeywordEntityTonalityWordCount,
  KeywordEntityTonalityCCM,
  KeywordEntityTonalityReach,
  KeywordEntityTrendIndex,
  KeywordEntityTrendNOA,
  KeywordEntityTrendMAV,
  KeywordEntityTrendWordCount,
  KeywordEntityTrendCCM,
  KeywordEntityTrendReach,

  KeywordPublicationTonalityIndex,
  KeywordPublicationTonalityNOA,
  KeywordPublicationTonalityMAV,
  KeywordPublicationTonalityWordCount,
  KeywordPublicationTonalityCCM,
  KeywordPublicationTonalityReach,
  KeywordPublicationTrendIndex,
  KeywordPublicationTrendNOA,
  KeywordPublicationTrendMAV,
  KeywordPublicationTrendWordCount,
  KeywordPublicationTrendCCM,
  KeywordPublicationTrendReach,
  KeywordPublicationSOVIndex,
  KeywordPublicationSOVNOA,
  KeywordPublicationSOVMAV,
  KeywordPublicationSOVWordCount,
  KeywordPublicationSOVCCM,
  KeywordPublicationSOVReach,

  KeywordJournalistTonalityIndex,
  KeywordJournalistTonalityNOA,
  KeywordJournalistTonalityMAV,
  KeywordJournalistTonalityWordCount,
  KeywordJournalistTonalityCCM,
  KeywordJournalistTonalityReach,
  KeywordJournalistTrendIndex,
  KeywordJournalistTrendNOA,
  KeywordJournalistTrendMAV,
  KeywordJournalistTrendWordCount,
  KeywordJournalistTrendCCM,
  KeywordJournalistTrendReach,
  KeywordJournalistSOVIndex,
  KeywordJournalistSOVNOA,
  KeywordJournalistSOVMAV,
  KeywordJournalistSOVWordCount,
  KeywordJournalistSOVCCM,
  KeywordJournalistSOVReach,

  KeywordCityTonalityIndex,
  KeywordCityTonalityNOA,
  KeywordCityTonalityMAV,
  KeywordCityTonalityWordCount,
  KeywordCityTonalityCCM,
  KeywordCityTonalityReach,
  KeywordCityTrendIndex,
  KeywordCityTrendNOA,
  KeywordCityTrendMAV,
  KeywordCityTrendWordCount,
  KeywordCityTrendCCM,
  KeywordCityTrendReach,
  KeywordCitySOVIndex,
  KeywordCitySOVNOA,
  KeywordCitySOVMAV,
  KeywordCitySOVWordCount,
  KeywordCitySOVCCM,
  KeywordCitySOVReach,

  KeywordSpokespersonTonalityIndex,
  KeywordSpokespersonTonalityNOA,
  KeywordSpokespersonTonalityMAV,
  KeywordSpokespersonTonalityWordCount,
  KeywordSpokespersonTonalityCCM,
  KeywordSpokespersonTonalityReach,
  KeywordSpokespersonTrendIndex,
  KeywordSpokespersonTrendNOA,
  KeywordSpokespersonTrendMAV,
  KeywordSpokespersonTrendWordCount,
  KeywordSpokespersonTrendCCM,
  KeywordSpokespersonTrendReach,
  KeywordSpokespersonSOVIndex,
  KeywordSpokespersonSOVNOA,
  KeywordSpokespersonSOVMAV,
  KeywordSpokespersonSOVWordCount,
  KeywordSpokespersonSOVCCM,
  KeywordSpokespersonSOVReach,
} = REPORT_TYPES;

export default function WidgetInlineFilters({
  widget,
  selectedInlinePublication,
  setSelectedInlinePublication,
  selectedInlineJournalist,
  setSelectedInlineJournalist,
  selectedEdition,
  setSelectedEdition,
  editionList,
  selectedInlineWCType,
  setSelectedInlineWCType,
  setSelectedInlineSentiment,
  selectedInlineSentiment,
  selectedInlinePlatform,
  setSelectedInlinePlatform,
  selectedInlineEntity,
  setSelectedInlineEntity,
  reportCategory,
  entityList,
  selectedInlineWCEntity,
  setSelectedInlineWCEntity,
  setSelectedInlineInfluencerEntity,
  selectedInlineInfluencerEntity,
  journalistList,
  selectedInlineZone,
  setSelectedInlineZone,
  selectedInlineGenre,
  setSelectedInlineGenre,
  selectedInlinePrintPublication,
  setSelectedInlinePrintPublication,
  publicationPrintInlineList,
  publicationOnlineInlineList,
  selectedInlineDynamicFilter,
  setSelectedInlineDynamicFilter,
  dynamicFilterList,
  selectedInlineDynamicFilterTwo,
  setSelectedInlineDynamicFilterTwo,
  dynamicFilterListTwo,
  selectedInlineGraphType,
  reportTypeList,
  selectedReportFilter,
  setSelectedReportFilter,
  spokespersonList,
  selectedInlineSpokesperson,
  setSelectedInlineSpokesperson,
  keywordList,
  sentimentList,
}) {
  const {
    inlineFilterApiData: {
      TopMediaDataPrint,
      TopJournalistDataOnline,
      TopJournalistDataPrint,
      TopPublicationClientPrint,
      TopPublicationClientOnline,
    },
  } = useSelector((state) => state.widgetReducer);
  const { type, report_type } = widget || {};
  const entity = useSelector((state) => state.filterReducer.socialEntityFilter);

  const zones = useSelector((state) => state.filterReducer.zoneFilter);

  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const id = selectedClient && selectedClient.id;

  const shouldShowZoneFilter = () => {
    const allowedAnalysisTypes = [];
    if (allowedAnalysisTypes.indexOf(report_type) !== -1) {
      return true;
    }
  };

  const shouldShowEntityFilter = () => {
    return (
      ((report_type === SOVKeywordRankingCCM ||
        report_type === SOVKeywordRankingIndex ||
        report_type === SOVKeywordRankingNOA ||
        report_type === SOVKeywordRankingMAV ||
        report_type === SOVKeywordRankingWordCount ||
        report_type === SOVKeywordRankingReach) &&
        selectedInlineGraphType === GRAPH_TYPES.PIE) ||
      report_type === SOVPublicationTonalityCCM ||
      report_type === SOVPublicationTonalityIndex ||
      report_type === SOVPublicationTonalityNOA ||
      report_type === SOVPublicationTonalityMAV ||
      report_type === SOVPublicationTonalityWordCount ||
      report_type === SOVPublicationTonalityReach ||
      report_type === SOVCityTonalityCCM ||
      report_type === SOVCityTonalityIndex ||
      report_type === SOVCityTonalityNOA ||
      report_type === SOVCityTonalityMAV ||
      report_type === SOVCityTonalityWordCount ||
      report_type === SOVCityTonalityReach ||
      report_type === SOVKeywordTrendCCM ||
      report_type === SOVKeywordTrendIndex ||
      report_type === SOVKeywordTrendNOA ||
      report_type === SOVKeywordTrendMAV ||
      report_type === SOVKeywordTrendWordCount ||
      report_type === SOVKeywordTrendReach ||
      ((report_type === SOVCityRankingCCM ||
        report_type === SOVCityRankingIndex ||
        report_type === SOVCityRankingNOA ||
        report_type === SOVCityRankingMAV ||
        report_type === SOVCityRankingWordCount ||
        report_type === SOVCityRankingReach) &&
        selectedInlineGraphType === GRAPH_TYPES.PIE) ||
      report_type === SOVPublicationTrendCCM ||
      report_type === SOVPublicationTrendIndex ||
      report_type === SOVPublicationTrendNOA ||
      report_type === SOVPublicationTrendMAV ||
      report_type === SOVPublicationTrendWordCount ||
      report_type === SOVPublicationTrendReach ||
      report_type === SOVJournalistTrendCCM ||
      report_type === SOVJournalistTrendIndex ||
      report_type === SOVJournalistTrendNOA ||
      report_type === SOVJournalistTrendMAV ||
      report_type === SOVJournalistTrendWordCount ||
      report_type === SOVJournalistTrendReach ||
      report_type === SOVCityTrendCCM ||
      report_type === SOVCityTrendIndex ||
      report_type === SOVCityTrendNOA ||
      report_type === SOVCityTrendMAV ||
      report_type === SOVCityTrendWordCount ||
      report_type === SOVCityTrendReach ||
      ((report_type === SOVJournalistRankingCCM ||
        report_type === SOVJournalistRankingIndex ||
        report_type === SOVJournalistRankingNOA ||
        report_type === SOVJournalistRankingMAV ||
        report_type === SOVJournalistRankingWordCount ||
        report_type === SOVJournalistRankingReach) &&
        selectedInlineGraphType === GRAPH_TYPES.PIE) ||
      ((report_type === SOVPublicationRankingCCM ||
        report_type === SOVPublicationRankingIndex ||
        report_type === SOVPublicationRankingNOA ||
        report_type === SOVPublicationRankingMAV ||
        report_type === SOVPublicationRankingWordCount ||
        report_type === SOVPublicationRankingReach) &&
        selectedInlineGraphType === GRAPH_TYPES.PIE) ||
      report_type === SOVJournalistTonalityCCM ||
      report_type === SOVJournalistTonalityIndex ||
      report_type === SOVJournalistTonalityNOA ||
      report_type === SOVJournalistTonalityMAV ||
      report_type === SOVJournalistTonalityWordCount ||
      report_type === SOVJournalistTonalityReach ||
      report_type === SOVKeywordTonalityCCM ||
      report_type === SOVKeywordTonalityIndex ||
      report_type === SOVKeywordTonalityNOA ||
      report_type === SOVKeywordTonalityMAV ||
      report_type === SOVKeywordTonalityWordCount ||
      report_type === SOVKeywordTonalityReach ||
      ((report_type === SentimentPublicationSOVCCM ||
        report_type === SentimentPublicationSOVIndex ||
        report_type === SentimentPublicationSOVNOA ||
        report_type === SentimentPublicationSOVMAV ||
        report_type === SentimentPublicationSOVWordCount ||
        report_type === SentimentPublicationSOVReach) &&
        selectedInlineGraphType === GRAPH_TYPES.PIE) ||
      report_type === SentimentPublicationTrendCCM ||
      report_type === SentimentPublicationTrendIndex ||
      report_type === SentimentPublicationTrendNOA ||
      report_type === SentimentPublicationTrendMAV ||
      report_type === SentimentPublicationTrendWordCount ||
      report_type === SentimentPublicationTrendReach ||
      ((report_type === SentimentJournalistSOVCCM ||
        report_type === SentimentJournalistSOVIndex ||
        report_type === SentimentJournalistSOVNOA ||
        report_type === SentimentJournalistSOVMAV ||
        report_type === SentimentJournalistSOVWordCount ||
        report_type === SentimentJournalistSOVReach) &&
        selectedInlineGraphType === GRAPH_TYPES.PIE) ||
      report_type === SentimentJournalistTrendCCM ||
      report_type === SentimentJournalistTrendIndex ||
      report_type === SentimentJournalistTrendNOA ||
      report_type === SentimentJournalistTrendMAV ||
      report_type === SentimentJournalistTrendWordCount ||
      report_type === SentimentJournalistTrendReach ||
      ((report_type === SentimentCitySOVCCM ||
        report_type === SentimentCitySOVIndex ||
        report_type === SentimentCitySOVNOA ||
        report_type === SentimentCitySOVMAV ||
        report_type === SentimentCitySOVReach) &&
        selectedInlineGraphType === GRAPH_TYPES.PIE) ||
      report_type === SentimentCityTrendCCM ||
      report_type === SentimentCityTrendIndex ||
      report_type === SentimentCityTrendNOA ||
      report_type === SentimentCityTrendMAV ||
      report_type === SentimentCityTrendReach ||
      ((report_type === SentimentKeywordSOVCCM ||
        report_type === SentimentKeywordSOVIndex ||
        report_type === SentimentKeywordSOVNOA ||
        report_type === SentimentKeywordSOVMAV ||
        report_type === SentimentKeywordSOVWordCount ||
        report_type === SentimentKeywordSOVReach) &&
        selectedInlineGraphType === GRAPH_TYPES.PIE) ||
      report_type === SentimentKeywordTrendCCM ||
      report_type === SentimentKeywordTrendIndex ||
      report_type === SentimentKeywordTrendNOA ||
      report_type === SentimentKeywordTrendMAV ||
      report_type === SentimentKeywordTrendWordCount ||
      report_type === SentimentKeywordTrendReach ||
      report_type === SpokespersonJournalistTrendCCM ||
      report_type === SpokespersonJournalistTrendIndex ||
      report_type === SpokespersonJournalistTrendNOA ||
      report_type === SpokespersonJournalistTrendMAV ||
      report_type === SpokespersonJournalistTrendWordCount ||
      report_type === SpokespersonJournalistTrendReach ||
      report_type === SpokespersonProfileTrendCCM ||
      report_type === SpokespersonProfileTrendIndex ||
      report_type === SpokespersonProfileTrendNOA ||
      report_type === SpokespersonProfileTrendMAV ||
      report_type === SpokespersonProfileTrendWordCount ||
      report_type === SpokespersonProfileTrendReach ||
      report_type === SpokespersonTopicTrendCCM ||
      report_type === SpokespersonTopicTrendIndex ||
      report_type === SpokespersonTopicTrendNOA ||
      report_type === SpokespersonTopicTrendMAV ||
      report_type === SpokespersonTopicTrendWordCount ||
      report_type === SpokespersonTopicTrendReach ||
      (/geolocation/i.test(report_type) &&
        /sov/i.test(report_type) &&
        !/entity/i.test(report_type) &&
        !/tonality/i.test(report_type)) ||
      (/geolocation/i.test(report_type) &&
        /trend/i.test(report_type) &&
        (!/Entity/.test(report_type) || type === V_ONLINE)) ||
      (reportCategory === REPORT_CATEGORIES.PUBLICATION &&
        (/sov/i.test(report_type) ||
          /Trend/.test(report_type) ||
          /Tonality/.test(report_type)) &&
        !/entity/i.test(report_type)) ||
      (reportCategory === REPORT_CATEGORIES.JOURNALIST &&
        /trend/i.test(report_type) &&
        !/entity/i.test(report_type)) ||
      (reportCategory === REPORT_CATEGORIES.THEMATIC_ANALYSIS &&
        /trend/i.test(report_type) &&
        !/entity/i.test(report_type)) ||
      (reportCategory === REPORT_CATEGORIES.KEYWORD_CLOUD &&
        /trend/i.test(report_type) &&
        !/entity/i.test(report_type))
    );
  };
  const shouldShowDynamicFilter = () => {
    const notAllowedAnalysisTypes =
      report_type === REPORT_TYPES.ThematicEntitySOVCCM ||
      report_type === REPORT_TYPES.ThematicEntitySOVIndex ||
      report_type === REPORT_TYPES.ThematicEntitySOVMAV ||
      report_type === REPORT_TYPES.ThematicEntitySOVNOA ||
      report_type === REPORT_TYPES.ThematicEntitySOVReach ||
      report_type === REPORT_TYPES.ThematicEntitySOVWordCount;

    if (
      (reportCategory === REPORT_CATEGORIES.THEMATIC_ANALYSIS &&
        !notAllowedAnalysisTypes) ||
      (reportCategory === REPORT_CATEGORIES.THEMATIC_ANALYSIS &&
        selectedInlineGraphType === GRAPH_TYPES.PIE) ||
      (reportCategory === REPORT_CATEGORIES.GEOLOCATION && type === V_ONLINE) ||
      (/trend/i.test(report_type) && /geolocation/i.test(report_type)) ||
      (/geolocation/i.test(report_type) && /tonality/i.test(report_type)) ||
      report_type === KeywordPublicationSOVCCM ||
      report_type === KeywordPublicationSOVIndex ||
      report_type === KeywordPublicationSOVNOA ||
      report_type === KeywordPublicationSOVMAV ||
      report_type === KeywordPublicationSOVWordCount ||
      report_type === KeywordPublicationSOVReach ||
      (reportCategory === REPORT_CATEGORIES.JOURNALIST &&
        /keyword/i.test(report_type) &&
        /sov/i.test(report_type)) ||
      (reportCategory === REPORT_CATEGORIES.GEOLOCATION && type === V_ONLINE) ||
      (/trend/i.test(report_type) && /geolocation/i.test(report_type)) ||
      (/geolocation/i.test(report_type) && /tonality/i.test(report_type)) ||
      // (reportCategory === REPORT_CATEGORIES.PUBLICATION &&
      //   /Publication/.test(report_type) &&
      //   /sov/i.test(report_type)) ||
      (reportCategory === REPORT_CATEGORIES.PUBLICATION &&
        /Publication/.test(report_type) &&
        /trend/i.test(report_type))
    ) {
      return true;
    }
  };
  const shouldShowDynamicFilterTwo = () => {
    return false;
    // reportCategory === REPORT_CATEGORIES.PUBLICATION &&
    // /Trend/.test(report_type) &&
    // !/Entity/,test(report_type)
  };
  const shouldShowJournalistFilter = () => {
    return (
      report_type === JournalistKeywordTrendCCM ||
      report_type === JournalistKeywordTrendIndex ||
      report_type === JournalistKeywordTrendNOA ||
      report_type === JournalistKeywordTrendMAV ||
      report_type === JournalistKeywordTrendWordCount ||
      report_type === JournalistKeywordTrendReach ||
      report_type === JournalistKeywordTonalityCCM ||
      report_type === JournalistKeywordTonalityIndex ||
      report_type === JournalistKeywordTonalityNOA ||
      report_type === JournalistKeywordTonalityMAV ||
      report_type === JournalistKeywordTonalityWordCount ||
      report_type === JournalistKeywordTonalityReach ||
      report_type === JournalistEntityTrendCCM ||
      report_type === JournalistEntityTrendIndex ||
      report_type === JournalistEntityTrendNOA ||
      report_type === JournalistEntityTrendMAV ||
      report_type === JournalistEntityTrendWordCount ||
      report_type === JournalistEntityTrendReach ||
      report_type === JournalistEntityTonalityCCM ||
      report_type === JournalistEntityTonalityIndex ||
      report_type === JournalistEntityTonalityNOA ||
      report_type === JournalistEntityTonalityMAV ||
      report_type === JournalistEntityTonalityWordCount ||
      report_type === JournalistEntityTonalityReach
    );
  };

  const shouldShowKeywordFilter = () => {
    return (
      report_type === KeywordPublicationTrendCCM ||
      report_type === KeywordPublicationTrendIndex ||
      report_type === KeywordPublicationTrendNOA ||
      report_type === KeywordPublicationTrendMAV ||
      report_type === KeywordPublicationTrendWordCount ||
      report_type === KeywordPublicationTrendReach ||
      report_type === KeywordPublicationTonalityCCM ||
      report_type === KeywordPublicationTonalityIndex ||
      report_type === KeywordPublicationTonalityNOA ||
      report_type === KeywordPublicationTonalityMAV ||
      report_type === KeywordPublicationTonalityWordCount ||
      report_type === KeywordPublicationTonalityReach ||
      report_type === KeywordEntityTrendCCM ||
      report_type === KeywordEntityTrendIndex ||
      report_type === KeywordEntityTrendNOA ||
      report_type === KeywordEntityTrendMAV ||
      report_type === KeywordEntityTrendWordCount ||
      report_type === KeywordEntityTrendReach ||
      report_type === KeywordEntityTonalityCCM ||
      report_type === KeywordEntityTonalityIndex ||
      report_type === KeywordEntityTonalityNOA ||
      report_type === KeywordEntityTonalityMAV ||
      report_type === KeywordEntityTonalityWordCount ||
      report_type === KeywordEntityTonalityReach ||
      report_type === KeywordCityTrendCCM ||
      report_type === KeywordCityTrendIndex ||
      report_type === KeywordCityTrendNOA ||
      report_type === KeywordCityTrendMAV ||
      report_type === KeywordCityTrendWordCount ||
      report_type === KeywordCityTrendReach ||
      report_type === KeywordCityTonalityCCM ||
      report_type === KeywordCityTonalityIndex ||
      report_type === KeywordCityTonalityNOA ||
      report_type === KeywordCityTonalityMAV ||
      report_type === KeywordCityTonalityWordCount ||
      report_type === KeywordCityTonalityReach ||
      report_type === KeywordJournalistTrendCCM ||
      report_type === KeywordJournalistTrendIndex ||
      report_type === KeywordJournalistTrendNOA ||
      report_type === KeywordJournalistTrendMAV ||
      report_type === KeywordJournalistTrendWordCount ||
      report_type === KeywordJournalistTrendReach ||
      report_type === KeywordJournalistTonalityCCM ||
      report_type === KeywordJournalistTonalityIndex ||
      report_type === KeywordJournalistTonalityNOA ||
      report_type === KeywordJournalistTonalityMAV ||
      report_type === KeywordJournalistTonalityWordCount ||
      report_type === KeywordJournalistTonalityReach ||
      report_type === KeywordSpokespersonTrendCCM ||
      report_type === KeywordSpokespersonTrendIndex ||
      report_type === KeywordSpokespersonTrendNOA ||
      report_type === KeywordSpokespersonTrendMAV ||
      report_type === KeywordSpokespersonTrendWordCount ||
      report_type === KeywordSpokespersonTrendReach ||
      report_type === KeywordSpokespersonTonalityCCM ||
      report_type === KeywordSpokespersonTonalityIndex ||
      report_type === KeywordSpokespersonTonalityNOA ||
      report_type === KeywordSpokespersonTonalityMAV ||
      report_type === KeywordSpokespersonTonalityWordCount ||
      report_type === KeywordSpokespersonTonalityReach ||
      report_type === KeywordSpokespersonSOVCCM ||
      report_type === KeywordSpokespersonSOVIndex ||
      report_type === KeywordSpokespersonSOVNOA ||
      report_type === KeywordSpokespersonSOVMAV ||
      report_type === KeywordSpokespersonSOVWordCount ||
      report_type === KeywordSpokespersonSOVReach ||
      report_type === KeywordCitySOVCCM ||
      report_type === KeywordCitySOVIndex ||
      report_type === KeywordCitySOVNOA ||
      report_type === KeywordCitySOVMAV ||
      report_type === KeywordCitySOVWordCount ||
      report_type === KeywordCitySOVReach ||
      report_type === KeywordJournalistSOVCCM ||
      report_type === KeywordJournalistSOVIndex ||
      report_type === KeywordJournalistSOVNOA ||
      report_type === KeywordJournalistSOVMAV ||
      report_type === KeywordJournalistSOVWordCount ||
      report_type === KeywordJournalistSOVReach
    );
  };

  const shouldShowOTTlistFilter = () => {
    const allowedAnalysisTypes = [];
    if (allowedAnalysisTypes.indexOf(report_type) !== -1) {
      return true;
    }
  };

  const shouldShowPublicationFilter = () => {
    const allowedAnalysisTypes = [];
    if (allowedAnalysisTypes.indexOf(report_type) !== -1) {
      return true;
    }
  };

  const shouldShowCInfluencerEntityFilter = () => {
    return false;
    // return (
    // report_type == INFLUENCERS &&
    // (type == V_SOCIAL || type == V_BLOG || type == V_FORUM)
    // );
  };

  const shouldShowCityFilter = () => {
    const allowedAnalysisTypes = [];
    if (allowedAnalysisTypes.indexOf(report_type) !== -1) {
      return true;
    }
  };

  const shouldShowWordCloudTypeFilter = () => {
    return false;
    // return (
    //   report_type == KeywordCloudNOA &&
    //   (type == V_SOCIAL || type == V_BLOG || type == V_FORUM)
    // );
  };

  const shouldShowPublicationTypeFilter = () => {
    if (/newentity/i.test(report_type) === true) {
      return false;
    } else if (
      (reportCategory === REPORT_CATEGORIES.PUBLICATION &&
        /Publication/.test(report_type) &&
        (/trend/i.test(report_type) || /SOV/i.test(report_type))) ||
      (reportCategory === REPORT_CATEGORIES.PUBLICATION &&
        /tonality/i.test(report_type))
    ) {
      return true;
    } else {
      return false;
    }
  };

  const shouldShowSpokespersonFilter = () => {
    return (
      report_type === SpokespersonEntityTrendCCM ||
      report_type === SpokespersonEntityTrendIndex ||
      report_type === SpokespersonEntityTrendNOA ||
      report_type === SpokespersonEntityTrendMAV ||
      report_type === SpokespersonEntityTrendWordCount ||
      report_type === SpokespersonEntityTrendReach ||
      report_type === SpokespersonTopicTrendCCM ||
      report_type === SpokespersonTopicTrendIndex ||
      report_type === SpokespersonTopicTrendNOA ||
      report_type === SpokespersonTopicTrendMAV ||
      report_type === SpokespersonTopicTrendWordCount ||
      report_type === SpokespersonTopicTrendReach ||
      report_type === SpokespersonJournalistTrendCCM ||
      report_type === SpokespersonJournalistTrendIndex ||
      report_type === SpokespersonJournalistTrendNOA ||
      report_type === SpokespersonJournalistTrendMAV ||
      report_type === SpokespersonJournalistTrendWordCount ||
      report_type === SpokespersonJournalistTrendReach ||
      report_type === SpokespersonJournalistSOVCCM ||
      report_type === SpokespersonJournalistSOVIndex ||
      report_type === SpokespersonJournalistSOVNOA ||
      report_type === SpokespersonJournalistSOVMAV ||
      report_type === SpokespersonJournalistSOVWordCount ||
      report_type === SpokespersonJournalistSOVReach ||
      report_type === SpokespersonProfileTrendCCM ||
      report_type === SpokespersonProfileTrendIndex ||
      report_type === SpokespersonProfileTrendNOA ||
      report_type === SpokespersonProfileTrendMAV ||
      report_type === SpokespersonProfileTrendWordCount ||
      report_type === SpokespersonProfileTrendReach ||
      report_type === SpokespersonProfileSOVCCM ||
      report_type === SpokespersonProfileSOVIndex ||
      report_type === SpokespersonProfileSOVNOA ||
      report_type === SpokespersonProfileSOVMAV ||
      report_type === SpokespersonProfileSOVWordCount ||
      report_type === SpokespersonProfileSOVReach ||
      report_type === SpokespersonTopicSOVCCM ||
      report_type === SpokespersonTopicSOVIndex ||
      report_type === SpokespersonTopicSOVNOA ||
      report_type === SpokespersonTopicSOVMAV ||
      report_type === SpokespersonTopicSOVWordCount ||
      report_type === SpokespersonTopicSOVReach
    );
  };

  const shouldShowTonalityFilter = () => {
    return (
      ((report_type === SOVEntityTonalityCCM ||
        report_type === SOVEntityTonalityIndex ||
        report_type === SOVEntityTonalityNOA ||
        report_type === SOVEntityTonalityMAV ||
        report_type === SOVEntityTonalityWordCount ||
        report_type === SOVEntityTonalityReach ||
        report_type === SOVJournalistTonalityIndex ||
        report_type === SOVJournalistTonalityNOA ||
        report_type === SOVJournalistTonalityMAV ||
        report_type === SOVJournalistTonalityWordCount ||
        report_type === SOVJournalistTonalityCCM ||
        report_type === SOVJournalistTonalityReach ||
        report_type === SOVPublicationTonalityIndex ||
        report_type === SOVPublicationTonalityNOA ||
        report_type === SOVPublicationTonalityMAV ||
        report_type === SOVPublicationTonalityWordCount ||
        report_type === SOVPublicationTonalityCCM ||
        report_type === SOVPublicationTonalityReach ||
        report_type === SOVCityTonalityIndex ||
        report_type === SOVCityTonalityNOA ||
        report_type === SOVCityTonalityMAV ||
        report_type === SOVCityTonalityWordCount ||
        report_type === SOVCityTonalityCCM ||
        report_type === SOVCityTonalityReach ||
        report_type === SOVKeywordTonalityCCM ||
        report_type === SOVKeywordTonalityIndex ||
        report_type === SOVKeywordTonalityNOA ||
        report_type === SOVKeywordTonalityMAV ||
        report_type === SOVKeywordTonalityWordCount ||
        report_type === SOVKeywordTonalityReach) &&
        selectedInlineGraphType === GRAPH_TYPES.PIE) ||
      (/thematic/i.test(report_type) &&
        /tonality/i.test(report_type) &&
        !/entity/i.test(report_type)) ||
      report_type === SentimentEntityTrendCCM ||
      report_type === SentimentEntityTrendIndex ||
      report_type === SentimentEntityTrendNOA ||
      report_type === SentimentEntityTrendMAV ||
      report_type === SentimentEntityTrendWordCount ||
      report_type === SentimentEntityTrendReach ||
      report_type === SentimentEntitySOVCCM ||
      report_type === SentimentEntitySOVIndex ||
      report_type === SentimentEntitySOVNOA ||
      report_type === SentimentEntitySOVMAV ||
      report_type === SentimentEntitySOVWordCount ||
      report_type === SentimentEntitySOVReach ||
      report_type === SentimentPublicationTrendCCM ||
      report_type === SentimentPublicationTrendIndex ||
      report_type === SentimentPublicationTrendNOA ||
      report_type === SentimentPublicationTrendMAV ||
      report_type === SentimentPublicationTrendWordCount ||
      report_type === SentimentPublicationTrendReach ||
      report_type === SentimentPublicationSOVCCM ||
      report_type === SentimentPublicationSOVIndex ||
      report_type === SentimentPublicationSOVNOA ||
      report_type === SentimentPublicationSOVMAV ||
      report_type === SentimentPublicationSOVWordCount ||
      report_type === SentimentPublicationSOVReach ||
      report_type === SentimentJournalistTrendCCM ||
      report_type === SentimentJournalistTrendIndex ||
      report_type === SentimentJournalistTrendNOA ||
      report_type === SentimentJournalistTrendMAV ||
      report_type === SentimentJournalistTrendWordCount ||
      report_type === SentimentJournalistTrendReach ||
      report_type === SentimentJournalistSOVCCM ||
      report_type === SentimentJournalistSOVIndex ||
      report_type === SentimentJournalistSOVNOA ||
      report_type === SentimentJournalistSOVMAV ||
      report_type === SentimentJournalistSOVWordCount ||
      report_type === SentimentJournalistSOVReach ||
      report_type === SentimentKeywordTrendCCM ||
      report_type === SentimentKeywordTrendIndex ||
      report_type === SentimentKeywordTrendNOA ||
      report_type === SentimentKeywordTrendMAV ||
      report_type === SentimentKeywordTrendWordCount ||
      report_type === SentimentKeywordTrendReach ||
      report_type === SentimentKeywordSOVCCM ||
      report_type === SentimentKeywordSOVIndex ||
      report_type === SentimentKeywordSOVNOA ||
      report_type === SentimentKeywordSOVMAV ||
      report_type === SentimentKeywordSOVWordCount ||
      report_type === SentimentKeywordSOVReach ||
      report_type === SentimentCityTrendCCM ||
      report_type === SentimentCityTrendIndex ||
      report_type === SentimentCityTrendNOA ||
      report_type === SentimentCityTrendMAV ||
      report_type === SentimentCityTrendReach ||
      report_type === SentimentCitySOVCCM ||
      report_type === SentimentCitySOVIndex ||
      report_type === SentimentCitySOVNOA ||
      report_type === SentimentCitySOVMAV ||
      report_type === SentimentCitySOVReach ||
      (type === V_ONLINE &&
        /entity/i.test(report_type) &&
        /geolocation/i.test(report_type) &&
        /tonality/i.test(report_type)) ||
      (type === V_PRINT &&
        !/entity/i.test(report_type) &&
        /geolocation/i.test(report_type) &&
        /tonality/i.test(report_type)) ||
      (reportCategory === REPORT_CATEGORIES.PUBLICATION &&
        /tonality/i.test(report_type)) ||
      (reportCategory === REPORT_CATEGORIES.JOURNALIST &&
        /tonality/i.test(report_type) &&
        /keyword/i.test(report_type)) ||
      (reportCategory === REPORT_CATEGORIES.KEYWORD_CLOUD &&
        /tonality/i.test(report_type) &&
        !/entity/i.test(report_type))
    );
  };

  const shouldShowChannelTypeFilter = () => {
    return false;
    // return (
    //   report_type == PLATFORM_TONALITY ||
    //   report_type == PLATFORM_TREND ||
    //   report_type == CitySpecificReport
    // );
  };

  const listOfPlatforms = [];
  // report_type == PLATFORM_TONALITY
  //   ? SOCIAL_SOURCES_OPTIONS.filter((e) => e.showInFilters)
  //   : SOCIAL_SOURCES_OPTIONS;

  let publicationList = [];
  // (type == V_PRINT
  //   ? TopPublicationClientPrint
  //   : TopPublicationClientOnline) || {};

  publicationList = publicationList.returnData;
  // let journalistList =
  //   (type == V_PRINT ? TopJournalistDataPrint : TopJournalistDataOnline) || {};
  // journalistList = journalistList.returnData;

  let ottList = (type == V_PRINT ? TopMediaDataPrint : {}) || {};
  ottList = ottList.returnData;

  const getOTTDefault = () => {
    const defaultSelectedItem =
      ottList && ottList.length
        ? ottList.filter((ele) => parseInt(ele.entity_id) == HOTSTAR_ID)
        : [];
    return defaultSelectedItem.length
      ? {
          value: defaultSelectedItem[0].entity_id,
          label: defaultSelectedItem[0].entity_name,
        }
      : "";
  };

  const genreList = [
    {
      value: 1,
      label: "Financial",
    },
    {
      value: 2,
      label: "Mainlines",
    },
    {
      value: 3,
      label: "Regional",
    },
    {
      value: 5,
      label: "Magazine",
    },
  ];
  const shouldShowSentimentGenre = () => {
    return report_type == 40 || report_type == 39;
  };
  const formattedEntList =
    shouldShowCInfluencerEntityFilter() &&
    entity &&
    entity.values.map(({ id, entity_name }) => {
      return {
        value: id,
        label: entity_name,
      };
    });
  const formatEntity =
    shouldShowWordCloudTypeFilter() &&
    entity &&
    entity.values.map(({ id, entity_name }) => {
      return {
        value: id,
        label: entity_name,
      };
    });
  return (
    <div className="filterOptions">
      {(type == V_PRINT || type == V_ONLINE) && (
        <>
          {shouldShowPublicationTypeFilter() && type === V_PRINT && (
            <div className="entityFilter">
              <CustomBSDropdown
                config={{
                  name: "Genre",
                  options:
                    publicationPrintInlineList &&
                    Array.isArray(publicationPrintInlineList) &&
                    publicationPrintInlineList.map((filter) => filter),
                }}
                selectedItem={selectedInlinePrintPublication}
                onSelect={setSelectedInlinePrintPublication}
              />
            </div>
          )}
          {shouldShowPublicationTypeFilter() && type === V_ONLINE && (
            <div className="entityFilter">
              <CustomBSDropdown
                config={{
                  name: "Genre",
                  options:
                    publicationOnlineInlineList &&
                    Array.isArray(publicationOnlineInlineList) &&
                    publicationOnlineInlineList.map((filter) => filter),
                }}
                selectedItem={selectedInlinePrintPublication}
                onSelect={setSelectedInlinePrintPublication}
              />
            </div>
          )}
          {shouldShowDynamicFilter() && (
            <div className="entityFilter">
              <CustomBSDropdown
                config={{
                  name: "Filter",
                  options:
                    dynamicFilterList &&
                    Array.isArray(dynamicFilterList) &&
                    dynamicFilterList.map((value) => {
                      return {
                        value: value,
                        label: value,
                      };
                    }),
                }}
                selectedItem={selectedInlineDynamicFilter}
                onSelect={setSelectedInlineDynamicFilter}
              />
            </div>
          )}
          {shouldShowDynamicFilterTwo() && (
            <div className="entityFilter">
              <CustomBSDropdown
                config={{
                  name: "Filter",
                  options:
                    dynamicFilterListTwo &&
                    Array.isArray(dynamicFilterListTwo) &&
                    dynamicFilterListTwo.map((value) => {
                      return {
                        value: value,
                        label: value,
                      };
                    }),
                }}
                selectedItem={selectedInlineDynamicFilterTwo}
                onSelect={setSelectedInlineDynamicFilterTwo}
              />
            </div>
          )}
          {shouldShowEntityFilter() && entityList && (
            <div className="entityFilter">
              <CustomBSDropdown
                config={{
                  name: "Entity",
                  options:
                    entityList &&
                    Array.isArray(entityList) &&
                    entityList.map((ent) => {
                      return {
                        value: ent.entity_name,
                        label: ent.entity_display_name,
                      };
                    }),
                }}
                selectedItem={selectedInlineEntity}
                onSelect={setSelectedInlineEntity}
              />
            </div>
          )}
          {shouldShowZoneFilter() && (
            <div className="entityFilter">
              <CustomBSDropdown
                config={{
                  name: "Zone",
                  options:
                    zones &&
                    Array.isArray(zones.values) &&
                    zones.values
                      .map((zone) => {
                        return {
                          value: zone.zone,
                          label: zone.zone,
                        };
                      })
                      .filter(
                        (zone) =>
                          zone.value !== "International" &&
                          zone.value !== "National"
                      ),
                }}
                selectedItem={selectedInlineZone}
                onSelect={setSelectedInlineZone}
              />
            </div>
          )}
          {shouldShowPublicationFilter() && (
            <div className="searchPublication">
              <CustomBSDropdown
                config={{
                  name: type == V_ONLINE ? "Website" : "Publication",
                  options:
                    Array.isArray(publicationList) &&
                    publicationList.map(
                      ({ publication_id, publication_name }) => {
                        return {
                          value: publication_id,
                          label: publication_name,
                        };
                      }
                    ),
                }}
                selectedItem={selectedInlinePublication}
                onSelect={setSelectedInlinePublication}
              />
            </div>
          )}

          {shouldShowJournalistFilter() && (
            <div className="entityFilter">
              <CustomBSDropdown
                config={{
                  name: "Journalist",
                  options:
                    Array.isArray(journalistList) &&
                    journalistList.map(({ source_id, source_name }) => {
                      return {
                        value: source_name,
                        label: source_name,
                      };
                    }),
                }}
                selectedItem={selectedInlineDynamicFilter}
                onSelect={setSelectedInlineDynamicFilter}
              />
            </div>
          )}

          {shouldShowOTTlistFilter() && (
            <div className="entityFilter">
              <CustomBSDropdown
                config={{
                  defaultOption: getOTTDefault(),
                  name: "",
                  options:
                    Array.isArray(ottList) &&
                    ottList.map(({ entity_id, entity_name }) => {
                      return {
                        value: entity_id,
                        label: entity_name,
                      };
                    }),
                }}
                selectedItem={selectedInlineJournalist}
                onSelect={setSelectedInlineJournalist}
                hideAllOption={true}
              />
            </div>
          )}

          {shouldShowCityFilter() && (
            <div className="cityFilter">
              <CustomBSDropdown
                config={{
                  name: "Edition",
                  options:
                    Array.isArray(editionList) &&
                    editionList.map((el) => {
                      return {
                        value: el.id,
                        label: el.edition_name,
                      };
                    }),
                }}
                selectedItem={selectedEdition}
                onSelect={setSelectedEdition}
              />
            </div>
          )}
        </>
      )}
      {shouldShowWordCloudTypeFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{
              name: "Word cloud type",
              options: WORD_CLOUD_TYPE,
              defaultOption: WORD_CLOUD_TYPE[0],
            }}
            selectedItem={selectedInlineWCType}
            onSelect={setSelectedInlineWCType}
          />
        </div>
      )}
      {shouldShowWordCloudTypeFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{
              name: "Entity",
              options: formatEntity,
              defaultOption: formatEntity[0],
            }}
            selectedItem={
              selectedInlineWCEntity ? selectedInlineWCEntity : formatEntity[0]
            }
            onSelect={setSelectedInlineWCEntity}
          />
        </div>
      )}

      {shouldShowTonalityFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{
              name: "Sentiment",
              options:
                sentimentList?.map((el) => {
                  return {
                    value: el,
                    label: el,
                  };
                }) || CONSTANTS.TONALITY,
            }}
            selectedItem={selectedInlineSentiment}
            onSelect={setSelectedInlineSentiment}
          />
        </div>
      )}

      {shouldShowChannelTypeFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{ name: "Platform", options: listOfPlatforms }}
            selectedItem={selectedInlinePlatform}
            onSelect={setSelectedInlinePlatform}
          />
        </div>
      )}
      {shouldShowCInfluencerEntityFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{
              name: "Entity",
              options: formattedEntList,
              defaultOption: formattedEntList[0],
            }}
            selectedItem={
              selectedInlineInfluencerEntity
                ? selectedInlineInfluencerEntity
                : formattedEntList[0]
            }
            onSelect={setSelectedInlineInfluencerEntity}
          />
        </div>
      )}
      {shouldShowSentimentGenre() && (
        <div className="searchGenre">
          <CustomBSDropdown
            config={{
              name: "Genre",
              options: genreList,
              defaultOption: genreList[0],
            }}
            selectedItem={
              selectedInlineGenre ? selectedInlineGenre : genreList[0]
            }
            onSelect={setSelectedInlineGenre}
          />
        </div>
      )}

      {shouldShowSpokespersonFilter() && (
        <div className="searchSpokesperson">
          <CustomBSDropdown
            config={{
              name: "Spokesperson",
              options:
                Array.isArray(spokespersonList) &&
                spokespersonList.map((el) => {
                  return {
                    value: el,
                    label: el,
                  };
                }),
              defaultOption: {
                value: spokespersonList[0],
                label: spokespersonList[0],
              },
            }}
            selectedItem={
              selectedInlineSpokesperson
                ? selectedInlineSpokesperson
                : spokespersonList[0]
            }
            onSelect={setSelectedInlineSpokesperson}
          />
        </div>
      )}
      {shouldShowKeywordFilter() && (
        <div className="entityFilter">
          <CustomBSDropdown
            config={{
              name: "Keyword",
              options:
                Array.isArray(keywordList) &&
                keywordList.map((keyword) => {
                  return {
                    value: keyword,
                    label: keyword,
                  };
                }),
            }}
            selectedItem={selectedInlineDynamicFilter}
            onSelect={setSelectedInlineDynamicFilter}
          />
        </div>
      )}
    </div>
  );
}
